const defaultFormrSettings = {
    fullWidth: true,
    hideSaveButton: false,
    hideResetButton: false,
    saveButtonText: 'Save',
    resetButtonText: 'Reset',
    alwaysEnableResetButton: false,
    autoSave: false
};
const formrSettings = () => {
    return structuredClone(defaultFormrSettings);
};
export { formrSettings };
//# sourceMappingURL=FormrSettings.js.map